import { render, staticRenderFns } from "./Extended.vue?vue&type=template&id=4bec19df"
import script from "./Extended.vue?vue&type=script&lang=js"
export * from "./Extended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports